import stakingHeroCaroMobile from "@/assets/images/staking-overview-caro-mobile.png"
import stakingHeroCaro from "@/assets/images/staking-overview-caro.png"
import stakingHeroPattern from "@/assets/images/staking-pattern.png"
import colors from "@/constants/colors"
import { CSSProperties } from "react"

export const heroWrapper = {
  pt: { xs: 3, md: 7.25 },
  pb: { xs: 5, md: 0 },
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  justifyContent: "space-between",
  gap: 3,
}

// TITLES
export const heroTitleImageWrapper = {
  position: "relative",
  maxWidth: { md: 400, lg: 570, lg2: 520, xl: 581 },
  pb: { xs: 5, md: 15 },
}

export const heroTitlePatternImage = {
  position: "absolute",
  width: "100%",
  height: "100%",
  left: 0,
  top: 0,
  backgroundImage: `url(${stakingHeroPattern.src})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: { xs: "369px 384px", md: "369px 384px", lg: "369px 384px" },
  backgroundPosition: "bottom 0px right 0px",
  zIndex: -1,
  opacity: 0.7,
}

export const heroTitleWrapper = {
  mb: 1,
}

export const heroTitle = {
  fontSize: { xs: 24, md: 28, lg: 40 },
  lineHeight: { xs: 1.5, lg: 1.4 },
  fontWeight: 700,
  color: colors.staking.dark,
}

export const heroTitleRelend = {
  ...heroTitle,
  color: colors.staking.primary,
}

export const heroDescriptionWrapper = {
  mb: 3,
  mt: 2,
}

export const heroDescriptionBold = {
  fontWeight: 700,
  color: colors.staking.gray2,
}

export const heroDescription = {
  color: colors.staking.gray3,
}

export const heroDescription2 = {
  ...heroDescription,
  mt: 3,
}

export const heroLearnMore = {
  color: colors.staking.primary,
  textUnderlineOffset: "2px",
  fontWeight: 700,
}

// STATS
export const heroStatWrapper = {
  flex: 1,
  maxWidth: { md: 728, md2: 552, lg: 728 },
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: 2,
  overflow: "visible",
}

export const heroStatCaro = {
  position: "absolute",
  width: { xs: 600, sm: 768, md: "100%" },
  height: { xs: 600, sm: 768, md: "100%" },
  left: { xs: -200, sm: -16, md: 0 },
  top: { xs: -225, sm: -260, md: 0 },
  zIndex: -10,
  backgroundImage: { xs: `url(${stakingHeroCaroMobile.src})`, md2: `url(${stakingHeroCaro.src})` },
  backgroundRepeat: "no-repeat",
  backgroundSize: { xs: "550px 396px", sm: "768px 553px", md: "630px 454px", lg: "630px 454px" },
  backgroundPosition: { xs: "bottom 0px right 0px", md: "bottom -30px right 0px" },
}

export const heroMascotWrapper = {
  position: "absolute",
  left: { md: 50, xl: 65 },
  top: { md: 10 },
  right: { xs: 0, md: "unset" },
  bottom: { xs: "95%", md: "unset" },
}

export const heroStatRectLineWrapper = {
  position: "absolute",
  left: "50%",
  top: 50,
  zIndex: 1,
}

export const heroMascotImage: CSSProperties = {
  position: "relative",
  zIndex: 2,
}

export const heroStatHorizontalLineWrapper = {
  position: "absolute",
  left: "calc(100% - 4px)",
  top: "77%",
  zIndex: 1,
  transform: "translateY(-77%)",
}

export const heroStatVerticalLineWrapper = {
  position: "absolute",
  left: "50%",
  top: "calc(100% - 4px)",
  zIndex: 1,
  transform: "translateX(-50%)",
}

// Stat cards
export const heroStatCardBase = {
  borderRadius: { xs: 2, md: 4 },
  border: 0,
  boxShadow: "none",
  overflow: "visible",
  position: { xs: "relative", md: "absolute" },
}

export const heroStatCardInside = {
  minWidth: { md: 217, lg: 247, lg2: 292 },
  minHeight: { xs: 100, md: 140 },
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: 0.5,
  px: { xs: 3, md: 1.5, lg: 2 },
  py: { xs: 1.25, md: 1.5, lg: 2 },
}

// Pink card
export const heroStatCardPink = {
  ...heroStatCardBase,
  left: { md: 10, lg: 32 },
  top: { md: 152, lg: 141, lg2: 140 },
  background: "linear-gradient(90.08deg, #FFFFFF 0.06%, #FAF4F0 105.89%)",
  "&:after": {
    content: '""',
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    borderRadius: { xs: 2, md: 4 },
    padding: "1px",
    background: "linear-gradient(290.89deg, rgba(255, 255, 255, 0.8) -22.24%, rgba(114, 151, 107, 0.8) 108.39%)",
    WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    MaskComposite: "exclude",
  },
}

export const heroStatCardPinkPattern = {
  position: "absolute",
  width: "100%",
  height: "100%",
  left: 0,
  top: 0,
  backgroundImage: `url(${stakingHeroPattern.src})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: { xs: "62px 65px", md: "62px 65px", lg: "62px 65px" },
  backgroundPosition: "bottom 0px right 0px",
  pointerEvents: "none",
  opacity: 0.7,
}

export const heroStatCardPinkTitle = {
  color: colors.staking.gray3,
  fontSize: { xs: 13, md: 16 },
  fontWeight: 500,
}

export const heroStatCardPinkStat = {
  color: colors.staking.dark,
  fontSize: { xs: 24, md: 28, lg: 40 },
  lineHeight: { xs: 1.5, lg: 1.4 },
  fontWeight: 700,
}

export const heroStatCardPinkValue = {
  color: colors.staking.gray3,
  fontSize: { xs: 13, md: 14 },
  fontWeight: 500,
}

export const iconWrapper = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
}

// Black card
export const heroStatCardBlack = {
  ...heroStatCardBase,
  right: { md: 38, lg: 48, lg2: 52, xl: 38 },
  top: { md: 10, lg: 0 },
  background: colors.staking.dark,
}

export const heroStatCardBlackTitle = {
  ...heroStatCardPinkTitle,
  color: "unset",
  background: "-webkit-linear-gradient(90.08deg, #FFFFFF 0.06%, #FAF4F0 105.89%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
}

export const heroStatCardBlackStat = {
  ...heroStatCardPinkStat,
  color: colors.staking.neutral,
}

export const heroStatCardBlackValue = {
  ...heroStatCardPinkValue,
  ...heroStatCardBlackTitle,
}

export const heroStatCardBlackPattern = {
  ...heroStatCardPinkPattern,
  opacity: 0.3,
}

// Green card
export const heroStatCardGreen = {
  ...heroStatCardBase,
  right: { md: 17, lg: 20 },
  top: { md: 218, lg: 208 },
  background: colors.staking.primary,
}

export const heroStatCardGreenTitle = {
  ...heroStatCardPinkTitle,
  color: "unset",
  background: "-webkit-linear-gradient(90.08deg, #FFFFFF 0.06%, #FAF4F0 105.89%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
}

export const heroStatCardGreenStat = {
  ...heroStatCardPinkStat,
  color: colors.staking.white,
}

export const heroStatCardGreenPattern = {
  ...heroStatCardPinkPattern,
}
